import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { ActorContextRow } from "./ActorContextRow";

export const SystemActorContextTypename = "SystemActorContext" as const;

export const SystemActorContextFragment = graphql(`
  fragment SystemActorContextFields on SystemActorContext {
    __typename
    source
  }
`);

interface Props {
  data: FragmentOf<typeof SystemActorContextFragment>;
}

export function SystemActorContext({ data }: Props) {
  const p = readFragment(SystemActorContextFragment, data);
  return <ActorContextRow>system · {p.source}</ActorContextRow>;
}
